var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F8E8DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3073_31442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.5V14.6C8.25 14.74 8.25 14.81 8.22275 14.8635C8.19878 14.9105 8.16054 14.9488 8.1135 14.9728C8.06002 15 7.99001 15 7.85 15H6.9C6.75999 15 6.68998 15 6.6365 14.9728C6.58946 14.9488 6.55122 14.9105 6.52725 14.8635C6.5 14.81 6.5 14.74 6.5 14.6V13.5M13.5 13.5V14.6C13.5 14.74 13.5 14.81 13.4728 14.8635C13.4488 14.9105 13.4105 14.9488 13.3635 14.9728C13.31 15 13.24 15 13.1 15H12.15C12.01 15 11.94 15 11.8865 14.9728C11.8395 14.9488 11.8012 14.9105 11.7772 14.8635C11.75 14.81 11.75 14.74 11.75 14.6V13.5M5.5 10H14.5M5.5 6.75H14.5M7.25 11.75H8M12 11.75H12.75M7.9 13.5H12.1C12.9401 13.5 13.3601 13.5 13.681 13.3365C13.9632 13.1927 14.1927 12.9632 14.3365 12.681C14.5 12.3601 14.5 11.9401 14.5 11.1V7.4C14.5 6.55992 14.5 6.13988 14.3365 5.81901C14.1927 5.53677 13.9632 5.3073 13.681 5.16349C13.3601 5 12.9401 5 12.1 5H7.9C7.05992 5 6.63988 5 6.31901 5.16349C6.03677 5.3073 5.8073 5.53677 5.66349 5.81901C5.5 6.13988 5.5 6.55992 5.5 7.4V11.1C5.5 11.9401 5.5 12.3601 5.66349 12.681C5.8073 12.9632 6.03677 13.1927 6.31901 13.3365C6.63988 13.5 7.05992 13.5 7.9 13.5Z",
    stroke: "#E04F16",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3073_31442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeBus);
export default __webpack_public_path__ + "static/media/orangeBus.2c73f802f4326f0f646a685d134173ba.svg";
export { ForwardRef as ReactComponent };